export default "__VITE_ASSET__189bfe60__"